import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export const FinalCta = () => {
  const { t } = useTranslation();

  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 md:py-32 bg-slate-950 overflow-hidden"
    >
      {/* Gradient orb */}
      <div
        className="absolute inset-0 opacity-40"
        style={{
          background:
            "radial-gradient(circle at 80% 50%, rgba(123,97,255,0.35) 0%, transparent 50%), radial-gradient(circle at 20% 50%, rgba(77,208,225,0.25) 0%, transparent 50%)",
        }}
      />
      {/* Grid */}
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
          maskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 70%)",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
          {t("finalCta.overline")}
        </p>
        <h2 className="mt-6 font-heading text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[0.95] text-white">
          {t("finalCta.title")}
        </h2>
        <p className="mt-8 max-w-2xl mx-auto text-lg leading-relaxed text-slate-300">
          {t("finalCta.subtitle")}
        </p>

        <div className="mt-12 flex flex-col items-center gap-4">
          <Link
            to="/contact"
            data-testid="contact-cta-btn"
            className="group relative inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-bold text-slate-900 transition-all hover:-translate-y-0.5 hover:shadow-2xl hover:shadow-white/20"
          >
            <span>{t("finalCta.cta")}</span>
            <ArrowRight
              size={16}
              weight="bold"
              className="transition-transform group-hover:translate-x-1"
            />
          </Link>
          <p className="text-xs text-slate-500">{t("finalCta.small")}</p>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
